module.exports = __webpack_public_path__ + "static/media/feat-chapter-img1.2d51809b.jpg";